export default __webpack_public_path__ + "static/media/9-shine.206b772b.png";